<div [formGroup]="formGroup" class="form-group" [class.has-error]="!isValid(formGroup, ctrl)" [libCtrConfigUI]="ctrl">
 
  <lib-title-label [formGroup]="formGroup" [enTheme]="enTheme" [isMobile]="isMobile" [ctrl]="ctrl" #lblTitle></lib-title-label>
 
  <p-gmap [id]="getId(ctrl)" [options]="options" [style]="{'width':getWidth(ctrl),'height':getHeight(ctrl, lblTittle)}"
  (onMapClick)="handleMapClick($event)" (onOverlayClick)="handleOverlayClick($event)"
  ></p-gmap>

</div>
